import * as types from "../../actions/actionTypes";
const initialState = {
  loadingPendingList: true,
  errorPendingList: "",
  dataPendingList: {},

  loadingCustodianBalance: true,
  errorCustodianBalance: "",
  dataCustodianBalance: [],

  loadingClassification: true,
  errorClassification: "",
  dataClassification: { account_title: [], cost_center: [] }
};

const Dashboard = (state = initialState, action) => {
  switch (action.type) {
    case types.MANAGER_DASHBOARD_GET_PENDING_LIST_REQUEST:
      return { ...state, loadingPendingList: true, errorPendingList: "" };
    case types.MANAGER_DASHBOARD_GET_PENDING_LIST_SUCCESS:
      return {
        ...state,
        dataPendingList: action.payLoad,
        loadingPendingList: false
      };
    case types.MANAGER_DASHBOARD_GET_PENDING_LIST_FAILURE:
      return {
        ...state,
        loadingPendingList: false,
        errorPendingList: action.error
      };

    case types.MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_REQUEST:
      return {
        ...state,
        loadingCustodianBalance: true,
        errorCustodianBalance: ""
      };
    case types.MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_SUCCESS:
      return {
        ...state,
        dataCustodianBalance: action.payLoad,
        loadingCustodianBalance: false
      };
    case types.MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_FAILURE:
      return {
        ...state,
        loadingCustodianBalance: false,
        errorCustodianBalance: action.error
      };

    case types.MANAGER_DASHBOARD_GET_CLASSIFICATION_REQUEST:
      return { ...state, loadingClassification: true, errorClassification: "" };
    case types.MANAGER_DASHBOARD_GET_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        dataClassification: action.payLoad,
        loadingClassification: false
      };
    case types.MANAGER_DASHBOARD_GET_CLASSIFICATION_FAILURE:
      return {
        ...state,
        loadingClassification: false,
        errorClassification: action.error
      };
    default:
      return state;
  }
};

export default Dashboard;
